import React from 'react';
import { bool, number, string } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import css from './SwimPlusDiscountBadge.module.css';

const SwimPlusDiscountBadge = (props) => {
  const {
    className,
    intl,
    isLevel1,
  } = props;
  const text = intl.formatMessage({ id: isLevel1 ? 'SwimPlusDiscountBadge.level1' : 'SwimPlusDiscountBadge.level2' });
  const classes = css.root;
  const swimPlusDiscountTextClasses = css.swimPlusDiscountText;

  return (
    <div className={classes}>
      {/*<IconPercentage className={css.iconBolt} />*/}
      <span className={swimPlusDiscountTextClasses}>{text}</span>
    </div>
  )
}

SwimPlusDiscountBadge.defaultProps = {
  className: null,
  iconOnly: false,
  swimPlusDiscountFrom: null,
  textOnly: false,
  withModal: false,
};

SwimPlusDiscountBadge.propTypes = {
  className: string,
  iconOnly: bool,
  swimPlusDiscountFrom: number,
  intl: intlShape.isRequired,
  textOnly: bool,
  withModal: bool,
};

export default injectIntl(SwimPlusDiscountBadge);
